document.querySelectorAll('.main-menu .menu-item').forEach(menuItem => {
  const secondLevelUL = menuItem.querySelector('ul.sub-ul');

  if (secondLevelUL) {
    const hasThirdLevel = secondLevelUL.querySelector('ul');

    // If NO third-level <ul> found inside second-level <ul>
    if (!hasThirdLevel) {
      secondLevelUL.classList.add('nohas3rd-level');
    }
  }
});


document.querySelectorAll('.dropdownn').forEach(dropdown => {
  if (dropdown.querySelector('.column-right')) {
    dropdown.classList.add('dropdownni');
  } else {
    dropdown.classList.add('dropdownnio');
  }
});

document.querySelectorAll('.nohas3rd-level').forEach(function(el) {
  const column = el.closest('.dropdown-column');
  if (column) {
    column.classList.add('dropdown-columnno3rd');
  }
});


document.addEventListener("DOMContentLoaded", function() {
  // Select all elements with the fourth_label_child_menu class
  const fourthMenus = document.querySelectorAll('.fourth_label_child_menu');

  fourthMenus.forEach(function(menu) {
    // Find the closest parent with both classes dropdownn and dropdownni
    const dropdownParent = menu.closest('.dropdownn.dropdownni');
    if (dropdownParent) {
      // Add the class fourth-v
      dropdownParent.classList.add('fourth-v');
    }
  });
});


document.addEventListener("DOMContentLoaded", function() {
  // Select all elements with the class fourth_label_child_menu
  const fourthMenus = document.querySelectorAll('.fourth_label_child_menu');

  fourthMenus.forEach(function(menu) {
    // Find all sibling elements
    const siblings = Array.from(menu.parentElement.children).filter(function(sib) {
      return sib !== menu && sib.classList.contains('sty');
    });

    // Add class 'oi' to those siblings
    siblings.forEach(function(sib) {
      sib.classList.add('has-dropdown-anchore', 'sst');
    });
  });
});



document.addEventListener("DOMContentLoaded", function() {
  // Select all third-level menu items
  const thirdMenuItems = document.querySelectorAll('li.submenu-item-3rd');

  thirdMenuItems.forEach(function(li) {
    // Get all classes of the li
    const liClasses = Array.from(li.classList);

    // Exclude base class(es) that are not used for matching
    const baseClasses = ['submenu-item-3rd'];
    const matchClasses = liClasses.filter(c => !baseClasses.includes(c));

    if (matchClasses.length > 0) {
      // Find all dropdown columns
      const dropdowns = document.querySelectorAll('.dropdown-column.column-right');

      dropdowns.forEach(function(dropdown) {
        // Get all classes of the dropdown
        const dropdownClasses = Array.from(dropdown.classList);

        // Check if li and dropdown share any class
        const shared = matchClasses.some(c => dropdownClasses.includes(c));
        if (shared) {
          // Add hover events
          li.addEventListener('mouseenter', function() {
            dropdown.style.opacity = '1';
          });
          li.addEventListener('mouseleave', function() {
            dropdown.style.opacity = '';
          });
        }
      });
    }
  });
});


// Select all elements with class 'undergrand'
const undergrandElements = document.querySelectorAll('.undergrand');

undergrandElements.forEach(el => {
  // Find the closest parent <li>
  const liParent = el.closest('li');

  // If a <li> parent exists, add the class 'mj'
  if (liParent) {
    liParent.classList.add('mj');
  }
});


// Hide all .undergrand elements initially
// document.querySelectorAll('.undergrand').forEach(el => {
//   el.style.display = 'none';
// });

// Select all elements that can trigger hover ('.sty' inside '.mj')
// document.querySelectorAll('.mj .sty').forEach(styEl => {
  // Mouse enter -> show the next sibling .undergrand
  // styEl.addEventListener('mouseenter', () => {
  //   const undergrand = styEl.nextElementSibling;
  //   if (undergrand && undergrand.classList.contains('undergrand')) {
  //     undergrand.style.display = 'block';
  //   }
  // });

  // Mouse leave -> hide the next sibling .undergrand
//   styEl.addEventListener('mouseleave', () => {
//     const undergrand = styEl.nextElementSibling;
//     if (undergrand && undergrand.classList.contains('undergrand')) {
//       undergrand.style.display = 'none';
//     }
//   });
// });

// // Class to add to the child
// const addClass = 'show-block';

// // Select all parents with the .mores class
// const parents = document.querySelectorAll('.mores');

// parents.forEach(parent => {
//     // Get parent class list (excluding 'mores' itself)
//     parent.classList.forEach(pClass => {
//         if (pClass === 'mores') return; // skip the .mores class

//         // Check if the parent has a child with the same class
//         const child = parent.querySelector(`.${pClass}`);
//         if (child) {
//             child.classList.add(addClass);
//         }
//     });
// });

// const addClass = 'highlight'; // class to add to the child

// document.querySelectorAll('.mores').forEach(parent => {
//     // Loop through all classes of the parent
//     parent.classList.forEach(pClass => {
//         // Skip 'mores' and 'activemores'
//         if (pClass === 'mores') return;

//         // Look for a child with the same class
//         const child = parent.querySelector(`.${pClass}`);
//         if (child) {
//             child.classList.add(addClass); // add the class
//         }
//     });
// });


const addClass = 'highlight'; // the class to add to matching child

// Select all parent elements that might contain children
document.querySelectorAll('.mores, .activemores').forEach(parent => {
    // Loop through all classes of the parent
    parent.classList.forEach(pClass => {
        // Skip base classes
        if (pClass === 'mores' || pClass === 'activemores') return;

        // Find child with the same class inside this parent
        const matchingChildren = parent.querySelectorAll(`.${pClass}`);
        matchingChildren.forEach(child => {
            child.classList.add(addClass); // add the highlight class
        });
    });
});


// document.addEventListener("DOMContentLoaded", function() {
//   document.querySelectorAll('.activemores').forEach(function(parent) {
//     const child = parent.querySelector('.fourts');
//     if (child && child.textContent.trim() === "") {
//       parent.style.display = "none !important";
//     }
//   });
// });
document.addEventListener("DOMContentLoaded", function() {
  document.querySelectorAll('.activemores').forEach(function(parent) {
    const child = parent.querySelector('.fourts');
    if (child && child.textContent.trim() === "") {
      parent.remove();
    }
  });
});



// hover class class


// click and hove backup
// $(document).ready(function() {
//     $('.nohas3rd-level .sub-ul-li').click(function(e) {
//         e.stopPropagation(); // prevent document click from firing immediately

//         const text = $(this).find('a').text().trim();

//         // Find matching div (whose class contains the text)
//         const $targetDiv = $('.newdemo .dropdown-column div').filter(function() {
//             return $(this).attr('class').toLowerCase().includes(text.toLowerCase());
//         });

//         // Remove 'activess' from all siblings
//         $targetDiv.siblings().removeClass('activess');

//         // Toggle 'activess' on the clicked div
//         $targetDiv.toggleClass('activess');

//         // Add/remove 'open' class on parent '.newdemo' based on children
//         $targetDiv.closest('.newdemo').toggleClass(
//             'open',
//             $targetDiv.closest('.newdemo').find('.activess').length > 0
//         );
//     });

//     // Clicking outside removes all
//     $(document).click(function(e) {
//         if (!$(e.target).closest('.nohas3rd-level, .newdemo').length) {
//             $('.newdemo .dropdown-column div').removeClass('activess');
//             $('.newdemo').removeClass('open');
//         }
//     });
// });



$(document).ready(function() {

  // Hover on menu item
  $('.nohas3rd-level .sub-ul-li').on('mouseenter', function() {
    const text = $(this).find('a').text().trim().toLowerCase();

    // Find target div based on class name
    const $targetDiv = $('.newdemo .dropdown-column div').filter(function() {
      return $(this).attr('class').toLowerCase().includes(text);
    });

    // Remove active state from all, add to matching one
    $('.newdemo .dropdown-column div').removeClass('activess');
    $targetDiv.addClass('activess');

    // Open dropdown
    $('.newdemo').addClass('open');
  });

  // Remove classes when mouse leaves menu or dropdown
  $(document).on('mousemove', function(e) {
    const $menu = $('.nohas3rd-level');
    const $dropdown = $('.newdemo');

    // If mouse is outside both menu and dropdown, remove classes
    if (!$menu.is(e.target) && $menu.has(e.target).length === 0 &&
        !$dropdown.is(e.target) && $dropdown.has(e.target).length === 0) {
      $('.newdemo .dropdown-column div').removeClass('activess');
      $('.newdemo').removeClass('open');
    }
  });

});



document.addEventListener('DOMContentLoaded', () => {
  const sourceDiv = document.querySelector('#powerdee'); // Div to move
  const originalParent = sourceDiv.parentNode;           // Original parent

  // Function to move div after target
  function moveAfter(div, target) {
    if (div && target) {
      target.parentNode.insertBefore(div, target.nextSibling);
    }
  }

  // Listen for clicks anywhere
  document.body.addEventListener('click', (e) => {
    const openSvg = e.target.closest('svg.icon.icon-theme-321');
    const menuBtn = e.target.closest('span.header__btn-menu.d-flex.align-items-center.d-lg-none.mr-20.cursor-pointer.js-popup-button');
    const closeSvg = e.target.closest('svg.icon.icon-theme-164');

    // Move into popup
    if (openSvg || menuBtn) {
      const popupObserver = new MutationObserver((mutations, observer) => {
        const target = document.querySelector('.popup.fixed-stretch.d-none.js-popup.active.show #op');
        if (target && sourceDiv) {
          moveAfter(sourceDiv, target);
          observer.disconnect(); // stop observing
        }
      });

      popupObserver.observe(document.body, { childList: true, subtree: true });
    }

    // Move back to original
    if (closeSvg && sourceDiv && originalParent) {
      originalParent.appendChild(sourceDiv);
    }
  });
});






